import * as angular from 'angular';
import { debouncedCall } from 'data/function';
import { ConditionComparison, ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { DEFAULT_VARIABLES_NAMES } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderService';
import { BuilderFeatures } from '../../../../BuilderFeatures';
import { CHANGED_DELAY } from '../../../../configurations/BuilderConfigurationSidebarController';
import { CardOutputContentIAction } from '../../../../historyActions';
import { ActionContentService } from '../../../../services/ActionContentService';
import { SUBFLOW_ID_PREFIX } from '../../../../services/BuilderStateService';
import { conditionFromAction } from '../../../actions/ActionController';
import OutputConditionCardView from './OutputConditionCardView.html';
export const conditionChangedEvent = 'output-condition-changed';
class OutputConditionCard {
    static $inject = ['$translate', '$timeout', 'CacheService', 'DEFAULT_PAGE_SIZE', 'VariablesService', 'MessagingHubService', 'BuilderSegmentService', 'UndoRedoService', '$rootScope', '$scope'];
    constructor($translate, $timeout, CacheService, DEFAULT_PAGE_SIZE, VariablesService, MessagingHubService, BuilderSegmentService, UndoRedoService, $rootScope, $scope) {
        'ngInject';
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.CacheService = CacheService;
        this.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
        this.VariablesService = VariablesService;
        this.MessagingHubService = MessagingHubService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.UndoRedoService = UndoRedoService;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.oldValues = [];
        this.isActionValueChange = false;
        this.isSubflowState = false;
        this.ActionContentService = ActionContentService.getInstance();
        this.saveOutput = (event) => {
            const { detail: { data } } = event;
            this.condition.values = data;
            this.oldValues = data;
            this.throttleOnChange();
        };
        this.changeValueSource = ({ detail: { value } }) => {
            this.condition.source = value;
            if (this.condition.source === ValueSource.Intent) {
                this.trackBuilderBlockAiActivated(ValueSource.Intent);
            }
            if (this.condition.source === ValueSource.Entity) {
                this.trackBuilderBlockAiActivated(ValueSource.Entity);
            }
            this.trackBlockOutputConditionIfEdited(value);
            this.throttleOnChange();
        };
        this.changeComparison = ({ detail: { value } }) => {
            this.condition.comparison = value;
            if (this.condition.comparison === ConditionComparison.Exists) {
                this.oldValues = this.conditionValues;
                this.condition.values = [];
            }
            else if (this.condition.comparison === ConditionComparison.NotExists) {
                this.trackBuilderBlockOutputConditionInputNotExistsAdded();
                this.oldValues = this.conditionValues;
                this.condition.values = [];
            }
            else if (this.condition.values &&
                this.condition.values.length === 0) {
                this.conditionValues = this.oldValues;
                this.condition.values = this.conditionValues;
            }
            this.trackBlockOutputConditionConditionEdited(value);
            this.throttleOnChange();
        };
        this.handleOnFocus = () => {
            this.getValueSuggestions();
        };
        this.getValueSuggestions = () => {
            const query = '';
            switch (this.condition.source) {
                case ValueSource.Input:
                    this.optionsData = this.state.$inputSuggestions
                        ? this.state.$inputSuggestions
                            .filter((i) => !query ||
                            i.toLowerCase().indexOf(query) >= 0)
                            .map((i) => ({ value: i, label: i }))
                        : [];
                    break;
                case ValueSource.Intent:
                    this.optionsData = this.intentions
                        .filter((i) => !query ||
                        i.name.toLowerCase().indexOf(query) >= 0)
                        .map((i) => ({ value: i.name, label: i.name }));
                    break;
                case ValueSource.Entity:
                    if (this.selectedEntity) {
                        const { resource } = this.MessagingHubService.ArtificialIntelligence
                            .getEntity(this.selectedEntity.id);
                        const entity = resource;
                        if (entity) {
                            this.optionsData = entity.values
                                .filter((e) => !query ||
                                e.name.toLowerCase().indexOf(query) >= 0)
                                .map((e) => ({ value: e.name, label: e.name }));
                        }
                    }
                    break;
            }
        };
    }
    async $onInit() {
        this.isSubflowState = this.state.id.startsWith(SUBFLOW_ID_PREFIX);
        this.condition.values && this.condition.values.length > 0
            ? (this.conditionValues = this.condition.values.map((i) => (i)))
            : (this.conditionValues = []);
        this.oldConditionOutput = angular.copy(this.state.$conditionOutputs);
        // Intitialize the arrays
        this.sources = [];
        this.comparisons = [];
        this.entities = [];
        this.variables = [];
        this.optionsData = [];
        // Async loading
        this.checkFeatures();
        this.loadSources();
        this.loadComparisons();
        this.loadIntentions();
        this.loadEntities();
        this.loadVariables();
        this.$scope.$on(conditionChangedEvent, (ev, outputs) => {
            const condition = outputs[this.outputIndex]?.conditions[this.index];
            this.$timeout(() => {
                if (!condition) {
                    return;
                }
                try {
                    this.condition = condition;
                    this.selectedEntity = condition?.entity;
                    this.selectedVariable.name = condition?.variable;
                    this.conditionValues = condition.values;
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                    //dispatching event input auto complete event
                    this.$scope.$broadcast('angucomplete-alt:changeInput', 'outputConditionVariable', this.selectedVariable);
                    this.onChange();
                }
            });
        });
        this.$rootScope.$on(conditionFromAction, () => {
            this.isActionValueChange = true;
        });
        customElements.whenDefined('bds-select').then(async () => {
            document.querySelectorAll('.reduced-blip-select').forEach(async (e) => {
                await e.componentOnReady();
                const shadowInput = e.shadowRoot.querySelector('input');
                shadowInput.setAttribute('style', 'width: 100%');
            });
        });
    }
    async checkFeatures() {
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
    }
    async loadSources() {
        if (this.application.isSubflow) {
            this.sources = [{
                    value: ValueSource.Input,
                    label: await this.$translate('builder-tabs-outputs.sources.input'),
                },
                {
                    value: ValueSource.Context,
                    label: await this.$translate('builder-tabs-outputs.sources.context'),
                }];
            return;
        }
        this.sources = [
            {
                value: ValueSource.Input,
                label: await this.$translate('builder-tabs-outputs.sources.input'),
            },
            {
                value: ValueSource.Context,
                label: await this.$translate('builder-tabs-outputs.sources.context'),
            },
            {
                value: ValueSource.Intent,
                label: await this.$translate('builder-tabs-outputs.sources.intention'),
            },
            {
                value: ValueSource.Entity,
                label: await this.$translate('builder-tabs-outputs.sources.entity'),
            },
        ];
    }
    async loadComparisons() {
        this.comparisons = [
            {
                value: ConditionComparison.Exists,
                label: await this.$translate('builder-tabs-outputs.comparisons.exists'),
            },
            {
                value: ConditionComparison.Equals,
                label: await this.$translate('builder-tabs-outputs.comparisons.equals'),
            },
            {
                value: ConditionComparison.NotEquals,
                label: await this.$translate('builder-tabs-outputs.comparisons.notEquals'),
            },
            {
                value: ConditionComparison.Contains,
                label: await this.$translate('builder-tabs-outputs.comparisons.contains'),
            },
            {
                value: ConditionComparison.StartsWith,
                label: await this.$translate('builder-tabs-outputs.comparisons.startsWith'),
            },
            {
                value: ConditionComparison.EndsWith,
                label: await this.$translate('builder-tabs-outputs.comparisons.endsWith'),
            },
            {
                value: ConditionComparison.GreaterThan,
                label: await this.$translate('builder-tabs-outputs.comparisons.greaterThan'),
            },
            {
                value: ConditionComparison.LessThan,
                label: await this.$translate('builder-tabs-outputs.comparisons.lessThan'),
            },
            {
                value: ConditionComparison.GreaterThanOrEquals,
                label: await this.$translate('builder-tabs-outputs.comparisons.greaterThanOrEquals'),
            },
            {
                value: ConditionComparison.LessThanOrEquals,
                label: await this.$translate('builder-tabs-outputs.comparisons.lessThanOrEquals'),
            },
            {
                value: ConditionComparison.ApproximateTo,
                label: await this.$translate('builder-tabs-outputs.comparisons.approximateTo'),
            },
            {
                value: ConditionComparison.Matches,
                label: await this.$translate('builder-tabs-outputs.comparisons.matches'),
            },
            {
                value: ConditionComparison.NotExists,
                label: await this.$translate('builder-tabs-outputs.comparisons.notExists'),
            },
        ];
    }
    loadVariables() {
        this.selectedVariable = {
            name: this.condition.variable,
        };
        this.variables = [
            ...DEFAULT_VARIABLES_NAMES.map((name) => ({ name })),
            ...this.VariablesService.userVariables.map((name) => ({ name })),
        ].sort(this.compareTexts);
    }
    compareTexts(a, b) {
        try {
            const textA = a.text.toLowerCase();
            const textB = b.text.toLowerCase();
            if (textA < textB) {
                return -1;
            }
            if (textA > textB) {
                return 1;
            }
            return 0;
        }
        catch (err) {
            return 0;
        }
    }
    async loadIntentions() {
        try {
            const intentions = await this.CacheService.getOrAdd(`${this.application.shortName}:intentions`, async () => {
                try {
                    const { resource } = await this.MessagingHubService.ArtificialIntelligence
                        .getIntents(0, this.DEFAULT_PAGE_SIZE);
                    return resource.items;
                }
                catch (e) {
                    return [];
                }
            }, 15000);
            this.intentions = intentions;
        }
        catch (e) {
            this.intentions = [];
        }
    }
    async loadEntities() {
        try {
            const entities = await this.CacheService.getOrAdd(`${this.application.shortName}:entities`, async () => {
                try {
                    const { resource } = await this.MessagingHubService.ArtificialIntelligence
                        .getEntities(0, 100);
                    return resource.items;
                }
                catch (e) {
                    return [];
                }
            }, 15000);
            this.entities = entities;
            this.selectedEntity = this.entities.find(e => e.name == this.condition.entity);
            if (this.condition.entity && !this.selectedEntity) {
                this.selectedEntity = this.condition.entity;
            }
        }
        catch (e) {
            this.entities = [];
        }
    }
    saveEntity() {
        this.condition.entity = this.selectedEntity
            ? this.selectedEntity.name
            : undefined;
        debouncedCall(CHANGED_DELAY, () => { this.throttleOnChange(); });
    }
    saveVariable() {
        this.condition.variable = this.selectedVariable
            ? this.selectedVariable.name
            : undefined;
        debouncedCall(CHANGED_DELAY, () => { this.throttleOnChange(); });
    }
    $onEdit($node) {
        this.onEdit({ $node });
    }
    removeCondition() {
        this.onRemove();
    }
    throttleOnChange() {
        if (this.currentTimeout) {
            this.$timeout.cancel(this.currentTimeout);
        }
        if (this.isBuilderUndoRedoOutputsEnabled && !this.ActionContentService.getIsEditingActionContent()) {
            if (this.oldConditionOutput === this.state.$conditionOutputs) {
                const cardContentIAction = new CardOutputContentIAction({
                    data: {
                        state: {
                            id: angular.copy(this.state.id),
                            $title: angular.copy(this.state.$title),
                        },
                        oldOutputs: angular.copy(this.oldConditionOutput),
                        newOutputs: angular.copy(this.state.$conditionOutputs),
                    },
                    execute: async (data) => {
                        this.state.$conditionOutputs = data.newOutputs;
                        this.oldConditionOutput = angular.copy(this.state.$conditionOutputs);
                        if (this.currentTimeout) {
                            this.$timeout.cancel(this.currentTimeout);
                        }
                        this.$rootScope.$broadcast(conditionChangedEvent, data.newOutputs);
                        this.$timeout(() => { this.onChange(); });
                    },
                    undo: async (data) => {
                        this.state.$conditionOutputs = data.oldOutputs;
                        this.oldConditionOutput = angular.copy(this.state.$conditionOutputs);
                        if (this.currentTimeout) {
                            this.$timeout.cancel(this.currentTimeout);
                        }
                        this.$rootScope.$broadcast(conditionChangedEvent, data.oldOutputs);
                        this.$timeout(() => { this.onChange(); });
                    },
                });
                this.UndoRedoService.add(cardContentIAction);
            }
        }
        this.oldConditionOutput = angular.copy(this.state.$conditionOutputs);
        this.$rootScope.$broadcast(conditionChangedEvent, this.state);
        this.$timeout(() => { this.onChange(); });
    }
    trackBuilderBlockAiActivated(aiType) {
        this.BuilderSegmentService.trackBuilderBlockAiActivated({
            BlockID: this.state.id,
            AiType: aiType,
        }, true);
    }
    trackBuilderBlockOutputConditionInputNotExistsAdded() {
        this.BuilderSegmentService.trackBuilderBlockOutputConditionInputNotExistsAdded({}, true);
    }
    trackBlockOutputConditionIfEdited(value) {
        this.BuilderSegmentService.trackBlockOutputConditionIfEdited({
            BlockID: this.state.id,
            selectedValue: value,
        }, true);
    }
    trackBlockOutputConditionConditionEdited(value) {
        this.BuilderSegmentService.trackBlockOutputConditionConditionEdited({
            BlockID: this.state.id,
            selectedValue: value,
        }, true);
    }
}
OutputConditionCard.$inject = ['$translate', '$timeout', 'CacheService', 'DEFAULT_PAGE_SIZE', 'VariablesService', 'MessagingHubService', 'BuilderSegmentService', 'UndoRedoService', '$rootScope', '$scope'];
export const OutputConditionCardComponent = {
    controller: OutputConditionCard,
    controllerAs: '$ctrl',
    template: OutputConditionCardView,
    bindings: {
        index: '<',
        outputIndex: '<',
        condition: '<',
        state: '<',
        application: '<?',
        onEdit: '&?',
        onChange: '&',
        onRemove: '&',
    },
};
